import { hash } from '@ember/helper';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import { not } from 'ember-truth-helpers';
import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsNewsletterConfigComponent extends Component {
  // Legal context
  loadLegalContext = trackedFunction(this, async () => {
    const legalContext = await this.args.model.legalContext;

    return legalContext?.id;
  });

  // Language select
  getLanguageLabel = (languageId = 0) => {
    const language = this.languages.find(({ value }) => value === languageId);

    return language?.label;
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar @sidebarPosition='right'>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='addressbookId' />
            <fieldset.field
              @property='newsletterForms'
              @type='has-many'
              @hasManySortable={{false}}
              @on={{hash
                openNewRecord=this.newRecord
                removeRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              as |record field|
            >
              <CpPanel @open={{record.isNew}} as |panel|>
                <panel.toggle>
                  {{this.getLanguageLabel record.language}}
                  &nbsp;|&nbsp;
                  {{record.formId}}
                </panel.toggle>
                <panel.body>
                  <Form
                    @model={{record}}
                    @parentModel={{form.model}}
                    @showErrors={{@showErrors}}
                    as |subform|
                  >
                    <subform.field
                      @property='language'
                      @type='select-value'
                      @disabled={{field.isDisabled}}
                      @options={{this.languages}}
                    />
                    <subform.field
                      @property='formId'
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='consentText'
                      @type='textarea'
                      @disabled={{field.isDisabled}}
                      @hint='Template: {newsletterName}, {dataSharing}, {link}, {/link}'
                      data-test-newsletter-consent-text
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>
        </:content>
        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='artist'
              @disabled={{true}}
              @type='belongs-to'
            />
            <fieldset.field @property='dataSharing' @type='checkbox' />
            <fieldset.field
              @property='dataSharingText'
              @disabled={{not form.model.dataSharing}}
            />
            <fieldset.field @property='legalContext' @type='belongs-to' />
            <fieldset.field
              @property='fallback'
              @type='belongs-to'
              @disabled={{this.loadLegalContext.isPending}}
              @filters={{hash
                type='crossArtist'
                legalContext=this.loadLegalContext.value
              }}
            />
          </form.fieldset>
          <form.sections.meta />
        </:sidebar>
      </ContentWithSidebar>

    </Form>
  </template>
}
